import React from 'react';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

function DownloadedTrackIssue() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/downloaded-track-issue" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="I have a problem with a downloaded track/album" />
      <p>
        If you had a problem with a downloaded track or release, please go to this release page and press complain link.
        <br />
        We will do our best to fix the issue and provide the best service for you.
        <br />
      </p>
      <HelpContactUs subject={3} />
    </div>
  );
}

export default DownloadedTrackIssue;
